import * as Yup from 'yup'

import { reusableRightValidation } from '../../validation'
import { STATUS } from '../../fields'

import { gamAccountFieldsValidation } from './gamAccountFieldsValidation'

export const getValidationSchema = (isGamAccountConnected = false) =>
  Yup.object({
    ...reusableRightValidation(isGamAccountConnected),
    [STATUS]: Yup.string().required('Please select status'),
    ...(isGamAccountConnected && gamAccountFieldsValidation)
  })
